'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16(evaluator$13) {
  this.Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16__f_evaluator$5 = null;
  this.Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16__f_evaluator$5 = evaluator$13;
}
export { $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16 as $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16 };
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16.prototype.constructor = $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16;
/** @constructor */
function $h_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16() {
}
export { $h_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16 as $h_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16 };
$h_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16.prototype = $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16.prototype;
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16__f_evaluator$5.apply__O();
  return (((typeof v) === "string") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16, "app.api.DrugRequestPharmacyState$ResponseGiven$$anon$16", ({
  Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16 as $d_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$16 };
//# sourceMappingURL=app.api.-Drug-Request-Pharmacy-State$-Response-Given$$anon$16.js.map
